$(document).ready(function(){
 if($("body").hasClass("template-cart"))
 {
     $(document).on("change",".template__cart__body .signature input[type='checkbox']",function(){
       $(".template__cart__body .insurance-loadr").show();
       if($(this).is(":checked"))
       {
         var id = $(this).attr("data-id");
         var qty = 1;
         addsig(id,qty);
       }
       else
       {
         var id = $(this).attr("data-id");
         var qty = 0;
         removesig(id,qty);
       }
       
     });
 }
 else
 {
       // $(document).on("change",".mini-cart__content .insurance input[type='checkbox']",function(){
       //   $(".mini-cart__content .insurance-loadr").show();
       //   if($(this).is(":checked"))
       //   {
       //     var id = $(this).attr("data-id");
       //     var qty = 1;
       //     add(id,qty);
       //   }
       //   else
       //   {
       //     var id = $(this).attr("data-id");
       //     var qty = 0;
       //     remove(id,qty);
       //   }

       // });    
 }
  
  
function addsig(id,qty)
{
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: qty,
        id: id,
        properties:{
          "Insurance":"Yes"
        }
      },
      dataType: 'json', 
      success: function (data) {
        if($("body").hasClass("template-cart"))
 		{
         location.reload();
        }
        else
        {
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              quantity: 1
            }
          }));
          
        }
      }
    });
}
  
function removesig(id,qty)
{
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        quantity: qty,
        id: id
      },
      dataType: 'json', 
      success: function (data) { 
        if($("body").hasClass("template-cart"))
 		{
         location.reload();
        }
        else
        {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
      }
    });
}
  
  var change = $(".signature-change").length;
  if(change != 0)
  {
    var hsitem = $(".signature-change").attr("data-init-id");
    var vid = $(".signature-change").attr("data-final-id");
    
    updateSignature(hsitem,vid);
    
  }
  
  document.addEventListener('product:added', function(event) {
    setTimeout(function () {
      var change = $(".signature-change").length;
      console.log(change);
      if(change != 0)
      {
        var hsitem = $(".signature-change").attr("data-init-id");
        var vid = $(".signature-change").attr("data-final-id");

        updateSignature(hsitem,vid);

      }
    }, 1000);  
  });
  

  
  function updateSignature(hsitem,vid){
  	$("button[name='checkout'],.checkout-upsell-mini").attr("disabled",'disabled');
    $(".signature-loadr").show();
    $(".signature-error").show();
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        quantity: 0,
        id: hsitem
      },
      dataType: 'json', 
      success: function (data) {
        if(vid != "")
        {
         $.ajax({
           type: 'POST',
           url: '/cart/add.js',
           data: {
             quantity: 1,
             id: vid,
             properties:{
               "Insurance":"Yes"
             }
           },
           dataType: 'json', 
           success: function (data) {
              if($("body").hasClass("template-cart"))
              {
                  location.reload();
              }
              else
              {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));

              }
            }
          });
        }
        else
        {
          $("button[name='checkout'],.checkout-upsell-mini").remove("disabled");
          $(".signature-loadr").hide();
          $(".signature-error").hide();
          if($("body").hasClass("template-cart"))
          {
             location.reload();
          }
          else
          {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
               bubbles: true
            }));

          }
        }
       }
     });
  }  

});